import { AxiosResponse } from 'axios'
import { IFilter, IWhere } from 'types/common'
import { AggregationPipeline } from 'types/common/aggregation'
import { api } from 'API'
import {
  ICreateSupportMessageThread,
  ISupportMessage,
  ISupportMessageThread,
  ISupportMessageThreadStatusHistory,
  ISupportThreadDto
} from 'interfaces/message'

export async function getSupportMessageThreads(filter: IFilter<ISupportMessageThread> = {}): Promise<any[]> {
  const response: AxiosResponse = await api.get(`/support-message-threads?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function getSupportThread(
  id: number,
  filter: IFilter<ISupportMessageThread> = {}
): Promise<ISupportMessageThread> {
  const response: AxiosResponse = await api.get(`/support-message-threads/${id}?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function getCountSupportMessageThreads(where: IWhere<ISupportMessageThread>): Promise<number> {
  const response: AxiosResponse = await api.get(`/support-message-threads/count?where=${JSON.stringify(where)}`)
  return +(response?.data?.count ?? 0)
}

export async function countAllUnreadSupportThread(pipeline: AggregationPipeline): Promise<number> {
  const response: AxiosResponse = await api.post(`/support-message-threads/count-all-notification`, { pipeline })
  return +(response?.data ?? 0)
}

export async function createSupportMessageThreads(data: ICreateSupportMessageThread): Promise<ISupportMessageThread> {
  const response = await api.post('/support-message-threads', data)
  return response?.data
}

export async function editSupportMessageThreads(
  threadId: number,
  data: Partial<ISupportMessageThread>
): Promise<number> {
  const response = await api.patch(`/support-message-threads/${threadId}`, data)
  return response?.data?.id ?? 0
}

export async function deleteSupportMessageThreads(threadId: number): Promise<void> {
  await api.delete(`/support-message-threads/${threadId}`)
}

export function createMessageInSupportThreads(
  threadId: number,
  messageThreads: { content: string; attachments?: { name: string; type: string }[] }
): Promise<ISupportMessageThread> {
  return api.post(`/support-message-threads/${threadId}/support-messages`, messageThreads)
}

export async function getSupportMessages(
  threadId: number,
  filter: IFilter<ISupportMessage> = {}
): Promise<ISupportMessage[]> {
  const res = await api.get(`/support-message-threads/${threadId}/support-messages?filter=${JSON.stringify(filter)}`)
  return res.data
}

export async function getSupportMessageAggregate(
  pipeline: AggregationPipeline,
  startDate: Date,
  endDate: Date
): Promise<ISupportThreadDto[]> {
  try {
    const response: AxiosResponse = await api.post(`/support-message-threads/aggregate`, {
      pipeline,
      startDate,
      endDate
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function countSupportMessageAggregate(pipeline: AggregationPipeline): Promise<number> {
  try {
    const response: AxiosResponse = await api.post(`/support-message-threads/aggregate/count`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return 0
  }
}

export async function getSupportMessageThreadStatusHistory(
  threadId: number
): Promise<ISupportMessageThreadStatusHistory[]> {
  const response = await api.get(`/support-message-threads/status-history/${threadId}`)
  return response?.data
}

export async function getAllUnreadSupportMessages(pipeline: AggregationPipeline): Promise<ISupportThreadDto[]> {
  const response: AxiosResponse = await api.post('/support-message-threads/get-all-unread-messages', {
    pipeline
  })
  return response?.data ?? []
}
